import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import { flowRight } from 'lodash';

import SavedCommissionsPage from './SavedCommissionsPage';

export default flowRight(withVerificationGuard, withAuthGuard())(SavedCommissionsPage);
